import { useContext } from 'react';
import { TimezoneContext, TimezoneContextType } from './TimezoneContext';

export const useTimezone = (): TimezoneContextType => {
  const context = useContext(TimezoneContext);
  if (context === undefined) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
};
